import { loginUser } from './IConfigUtils';
import { hashCode } from './StringUtils';
import { User } from '../components/User';

// Mocking localStorage
const localStorageMock = (function() {
    let store: { [key: string]: string } = {};
    return {
        getItem: function(key: string) {
            return store[key] || null;
        },
        setItem: function(key: string, value: string) {
            store[key] = value.toString();
        },
        clear: function() {
            store = {};
        }
    };
})();

Object.defineProperty(window, 'localStorage', {
    value: localStorageMock
});

// Mocking window.location
Object.defineProperty(window, 'location', {
    value: {
        search: '?config=default'
    },
    writable: true
});

describe('Login Tests', () => {
    beforeEach(() => {
        window.localStorage.clear();
    });

    test('should login as admin with correct credentials', () => {
        const result = loginUser('admin', 'cruzdiezadmin123!');
        expect(result.status).toBe(true);
        expect(result.user.name).toBe('admin');
        expect(result.user.type).toBe('admin');
    });

    test('should login as user with correct credentials', () => {
        const result = loginUser('user', 'user123');
        expect(result.status).toBe(true);
        expect(result.user.name).toBe('user');
        expect(result.user.type).toBe('user');
    });

    test('should fail login with incorrect password', () => {
        const result = loginUser('admin', 'wrongpassword');
        expect(result.status).toBe(false);
        expect(result.textStatus).toBe('incorrectLoginDetails');
    });

    test('should fail login with incorrect username', () => {
        const result = loginUser('nonexistent', 'password');
        expect(result.status).toBe(false);
    });

    test('should fail login with empty credentials', () => {
        const result = loginUser('', '');
        expect(result.status).toBe(false);
        expect(result.textStatus).toBe('pleaseEnterLoginDetails');
    });
});
